import { Subject } from 'rxjs';
import { ISubscriptionMonitor } from './subscription-monitor.interface';
import { ISubscriptionService } from './subscription-service.interface';

export class SubscriptionMonitor implements ISubscriptionMonitor {

    private _subject$: Subject<any> = new Subject<any>();

    public get subject$(): Subject<any> {
        return this._subject$;
    }

    public constructor(private _service?: ISubscriptionService) {}

    public unsubscribe(): void {
        this._subject$.next(null);
        this._subject$.complete();

        this._service?.unsubscribe(this);
    }
}
